import { useSelector } from 'react-redux';

import { RootState } from '@/redux/store';

export const useMLParcelAccess = () => {
  const { mlParcelAccess } = useSelector((state: RootState) => state.parcel);

  return {
    hasMLParcelAccess: mlParcelAccess.hasAccess,
    checked: mlParcelAccess.checked,
  };
};
